import { useEffect, useState } from 'react';
import type { CommunityQuestionBase } from '../../pages/Community/types/community-questions';
import { pickersDataService } from '../../services/pickersDataService';
import { BasePicker } from '../shared/BasePicker';

interface CommunityQuestionPickerProps {
    value: string;
    onChange: (question: CommunityQuestionBase | null) => void;
    label?: string;
    required?: boolean;
    className?: string;
    usageMap?: Record<string, string[]>;
}

export const CommunityQuestionPicker = ({
    value,
    onChange,
    label = "Community Question",
    required = false,
    className = "",
    usageMap
}: CommunityQuestionPickerProps) => {
    const [questions, setQuestions] = useState<CommunityQuestionBase[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadQuestions = async () => {
            try {
                setLoading(true);
                const fetchedQuestions = await pickersDataService.getAllCommunityQuestions();
                setQuestions(fetchedQuestions);
            } catch (error) {
                console.error('Failed to load community questions:', error);
            } finally {
                setLoading(false);
            }
        };

        loadQuestions();
    }, []);

    return (
        <BasePicker<CommunityQuestionBase>
            value={value}
            onChange={onChange}
            items={questions}
            config={{
                modalTitle: 'Select Community Question',
                searchPlaceholder: 'Search questions...',
                emptyStateMessage: loading ? 'Loading questions...' : 'No questions available',
                noSelectionMessage: 'No question selected',
                getItemId: (question) => question.id,
                getItemDisplayName: (question) => question.text,
                usageMap
            }}
            label={label}
            required={required}
            className={className}
        />
    );
};
